import { apiClient } from '@/lib/api/client'

export interface ServerCartItem {
  id: string          // cart_item id (dùng cho patch/delete)
  productId: string
  slug: string
  name: string
  brand: string
  image: string
  price: number
  oldPrice: number
  qty: number
  stock?: number | null
}

export interface ServerCart {
  items: ServerCartItem[]
  subtotal: number
  itemCount: number
}

export interface AddToCartPayload { productId: string; qty: number }
export interface UpdateQtyPayload { itemId: string; qty: number }
export interface MergeCartPayload { items: Array<{ productId: string; qty: number }> }

export const cartApi = {
  get:       ()                 => apiClient.get<ServerCart>('/cart').then((r) => r.data),
  add:       (p: AddToCartPayload) => apiClient.post<ServerCart>('/cart/items', p).then((r) => r.data),
  updateQty: ({ itemId, qty }: UpdateQtyPayload) =>
    apiClient.patch<ServerCart>(`/cart/items/${itemId}`, { qty }).then((r) => r.data),
  remove:    (itemId: string)   => apiClient.delete<ServerCart>(`/cart/items/${itemId}`).then((r) => r.data),
  clear:     ()                 => apiClient.delete<ServerCart>('/cart').then((r) => r.data),
  merge:     (p: MergeCartPayload) => apiClient.post<ServerCart>('/cart/merge', p).then((r) => r.data),
}
